/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GroupDocumentResponseDto { 
    id?: number;
    documentId?: string;
    documentTypeId?: number;
    creationTime?: string;
    groupId?: number;
    tenantId?: number;
    documentFileName?: string | null;
    isDeleted?: boolean;
    memberDocumentType?: string | null;
    comment?: string | null;
}

